// ----------------------- Action types ----------------------------
export const CHANGE_ACTIVE_ITEM_TS_EXPERT = "CH_TS_EXPERT";
export const CHANGE_ACTIVE_ITEM_CONFIG = "CH_CONFIG";
// ----------------------- Protocol ----------------------------
export const CHANGE_ACTIVE_ITEM_PROTOCOL_RESUME = "CH_RESUME";
export const CHANGE_ACTIVE_ITEM_PROTOCOL_LIVELIST = "CH_LIVELIST";
export const CHANGE_ACTIVE_ITEM_PROTOCOL_LIVELIST_MATRIX = "CH_LIVELIST_MATRIX";
export const CHANGE_ACTIVE_ITEM_PROTOCOL_GRAPHIC_TOPOLOGY = "CH_GRAPHIC_TOPOLOGY";
export const CHANGE_ACTIVE_ITEM_PROTOCOL_LOG = "CH_LOG";
export const CHANGE_ACTIVE_ITEM_PROTOCOL_DIAGNOSTIC = "CH_DIAGNOSTIC";
// ----------------------- Physical Medium DP ----------------------------
export const CHANGE_ACTIVE_ITEM_DN_LIVELIST = "CH_DN_LIVELIST";
export const CHANGE_ACTIVE_ITEM_DN_LIVELIST_MATRIX = "CH_DN_LIVELIST_MATRIX";
export const CHANGE_ACTIVE_ITEM_DN_OSCILLOSCOPE = "CH_DN_OSC";
export const CHANGE_ACTIVE_ITEM_DN_BAR_GRAPH = "CH_DN_BAR_GRAPH";
export const CHANGE_ACTIVE_ITEM_DN_LOG = "CH_DN_LOG";
// ----------------------- Solve Problem ----------------------------
export const SOLVE_PROBLEM = "SOLVE_PROBLEM";
// ----------------------- Change Route ----------------------------
export const CHANGE_ROUTE = "CH_ROUTE";